import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React from 'react';
import { ItemHandlingUnit } from '../../store/config/types';

export interface HandlingUnitListDialogProps {
  open: boolean;
  onClose: () => void;
  handlingUnits: ItemHandlingUnit[];
  title?: string;
}

export const HandlingUnitListDialog: React.FC<HandlingUnitListDialogProps> = ({
  open,
  onClose,
  handlingUnits,
  title = 'Handling Units',
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6">{title}</Typography>
      </DialogTitle>
      <DialogContent>
        {handlingUnits && handlingUnits.length > 0 ? (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Barcode</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Info</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {handlingUnits.map((hu, index) => (
                <TableRow key={hu.itemHandlingUnitId || hu.barcode || index}>
                  <TableCell>{hu.barcode}</TableCell>
                  <TableCell>
                    {hu.quantity.toFixed(2)} {hu.unit}
                  </TableCell>
                  <TableCell>
                    {hu.additionalInfo?.tare ? (
                      <>
                        Tare: {hu.additionalInfo.tare} {hu.additionalInfo.unit ?? ''}
                      </>
                    ) : (
                      ''
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography variant="body2" color="textSecondary" align="center" py={2}>
            No handling units available.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
